var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.761,
    height: 23.727,
    viewBox: "0 0 20.761 23.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-format",
    transform: "translate(-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7198",
    "data-name": "Path 7198",
    d: "M97.483,0A1.487,1.487,0,0,0,96,1.483V22.244a1.487,1.487,0,0,0,1.483,1.483h14.829a1.487,1.487,0,0,0,1.483-1.483V5.932L107.863,0Z",
    transform: "translate(-61.034)",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7199",
    "data-name": "Path 7199",
    d: "M353.483,5.932h4.449L352,0V4.449A1.487,1.487,0,0,0,353.483,5.932Z",
    transform: "translate(-305.171)",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7200",
    "data-name": "Path 7200",
    d: "M388.449,132.449,384,128h4.449Z",
    transform: "translate(-335.688 -122.068)",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7201",
    "data-name": "Path 7201",
    d: "M49.795,248.156a.744.744,0,0,1-.741.741H32.741a.744.744,0,0,1-.741-.741v-7.415a.744.744,0,0,1,.741-.741H49.053a.744.744,0,0,1,.741.741Z",
    transform: "translate(0 -228.878)",
    fill: "#f15642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5175",
    "data-name": "Group 5175",
    transform: "translate(35.232 13.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7202",
    "data-name": "Path 7202",
    d: "M101.744,294.729a.408.408,0,0,1,.4-.409h1.369a1.482,1.482,0,0,1,0,2.964h-.99v.783a.372.372,0,0,1-.38.409.4.4,0,0,1-.4-.409Zm.782.337v1.477h.99a.739.739,0,0,0,0-1.477Z",
    transform: "translate(-101.744 -294.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7203",
    "data-name": "Path 7203",
    d: "M188.233,299.574a.371.371,0,0,1-.409-.367V295.84a.4.4,0,0,1,.409-.368h1.358c2.709,0,2.65,4.1.053,4.1Zm.374-3.379v2.656h.984c1.6,0,1.672-2.656,0-2.656Z",
    transform: "translate(-183.835 -295.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7204",
    "data-name": "Path 7204",
    d: "M287.912,296.228v.942h1.512a.458.458,0,0,1,.427.42.412.412,0,0,1-.427.356h-1.512v1.245a.351.351,0,0,1-.355.367.377.377,0,0,1-.42-.367v-3.368a.375.375,0,0,1,.42-.368h2.081a.37.37,0,0,1,.415.368.41.41,0,0,1-.415.4h-1.726Z",
    transform: "translate(-278.545 -295.403)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7205",
    "data-name": "Path 7205",
    d: "M110.088,416.741H96v.741h14.088a.744.744,0,0,0,.741-.741V416A.744.744,0,0,1,110.088,416.741Z",
    transform: "translate(-61.034 -396.722)",
    fill: "#cad1d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.bbb61b585dcf4d3703affcce9a6dcb57.svg";
export { ForwardRef as ReactComponent };